import { useContext, useEffect, useState } from 'react';
import { TaskContext } from '../TitleCompany';
import {  Form } from 'antd';
import { useGetTaskResponsesByTask } from 'services/task/querys';
import { ArrowRightOutlined } from '@ant-design/icons';
import ModalFinish from './ModalFinish';
import { Task, TaskResponse, TaskState } from 'gql/graphql';
import SectionIssues from '../../../SectionIssues/SectionIssues';
import InputBorderNone from '../../components/Atoms/Inputs/InputBorderNone/InputBorderNone';
import ButtonSubmit from '../../components/Atoms/Buttons/ButtonSubmit/ButtonSubmit';
import ActionAcceptAndReject from '../../../ActionAcceptAndReject/ActionAcceptAndReject';
import StateTag from '../../components/Atoms/Tags/StateTag/StateTag';
import CardBorrowerImpersonation from '../../../CardBorrowerImpersonation/CardBorrowerImpersonation';
import AnnouncementBasic from '../../../Atoms/Announcements/AnnouncementBasic';

interface Props {
  closeTask: Function;
}

const Step1 = ({ closeTask }: Props) => {
  const [form] = Form.useForm();
  const task: Task | any = useContext(TaskContext);

  const { data: taskResponses } =
    useGetTaskResponsesByTask({
      variables: { findResponsesByTask: { taskId: task._id } }
    });

  const [modalFinish, setModalFinish] = useState<boolean>(false);
  const [response, setResponse] = useState<TaskResponse>();

  useEffect(() => {
    if (response)
      form.setFieldsValue(response.metadata);
  }, [response])

  useEffect(() => {
    const _response: any = taskResponses?.find((item) => item.step === 1);
    const _responseFromProcessing: any = (taskResponses ?? []).length > 1 ? taskResponses?.find((item) => item.step === 1 && item.key === 'contact-information') : null;
    if (_responseFromProcessing) {
      form.setFieldsValue(_responseFromProcessing.metadata);
      setResponse(_responseFromProcessing);
    }else if (_response) {
      setResponse(_response);
      form.setFieldsValue(_response.metadata);
    }
  }, [taskResponses]);


  return (
    <section>
      <div className="section-1">
        <h3 className="h3">
          Enter the contact information for the property’s title company/agent
          so we can order a title search
        </h3>

        {response && response.key === 'not-title' && (
          <AnnouncementBasic
            className='title-review mt-20'
            text='Borrower has requested a title company'
          />
        )}

        <CardBorrowerImpersonation hasResponses={taskResponses && taskResponses.length > 0} />
          
        <SectionIssues task={task} />

        <div className="mt-40" style={{ position: 'relative' }}>
          {response &&
            <ActionAcceptAndReject
              taskResponseId={response?._id}
              task={{ id: task._id, key: task.key, name: task.name }}
              files={response?.files}
              currentState={response?.state}
            />
          }
          <div className={`title-company-step-1 title-company-step-1-${response?.state}`}>

            {response?.state && response?.state !== TaskState.Review && <StateTag state={response?.state} />}
            {response?.state && response?.state === TaskState.Review && <StateTag state={response?.state} isLabelLocked />}

            <Form
              name="edit"
              autoComplete="off"
              requiredMark="optional"
              colon={false}
              form={form}
              disabled={true}
            >
              <Form.Item
                label=""
                name="titleCompany"
                className="titleCompany"
                rules={[{ required: true, message: '' }]}
              >
                <InputBorderNone
                  placeholder="Title company name"
                  className="bold"
                />
              </Form.Item>
              <Form.Item
                label="Contact name (if different from lender)"
                name="name"
                className="name"
                rules={[{ required: true, message: '' }]}
              >
                <InputBorderNone
                  placeholder="Edgar"
                  height={20}
                  className="bold-lith"
                />
              </Form.Item>

              <Form.Item
                label="Phone number"
                name="phone"
                className="phone"
                rules={[
                  { required: true, message: '' },
                  { min: 12, message: '' }
                ]}
              >
                <InputBorderNone
                  placeholder="329-230-2390"
                  height={20}
                  className="bold-lith"
                />
              </Form.Item>

              <Form.Item
                label="Email address"
                name="email"
                className="email"
                rules={[{ required: true, type: 'email', message: '' }]}
              >
                <InputBorderNone
                  type="email"
                  placeholder="ricardo@mervetscoolbiz.com"
                  height={20}
                  className="bold-lith"
                />
              </Form.Item>

              {response?.state !== TaskState.Approved &&
                <Form.Item className="submit" shouldUpdate>
                  {() => (
                    <ButtonSubmit
                      disabled={true}
                      modalConfirm={{ show: true }}
                      onClick={form.submit}
                    >
                      Submit and complete task
                    </ButtonSubmit>
                  )}
                </Form.Item>
              }
            </Form>
          </div>
        </div>
        <div className='mt-20'>
          <b className="blue-bold" style={{ fontWeight: 500, cursor: 'default' }}>
            I don’t have a title company. Give me one
          </b>{' '}
          <ArrowRightOutlined className="blue-bold" style={{ cursor: 'default' }} />
        </div>

        {modalFinish &&
          <ModalFinish
            visible={modalFinish}
            setVisible={setModalFinish}
            closeTask={closeTask}
          />
        }
      </div>
    </section>
  );
};
export default Step1;
